<template>
  <div id="login">
    <!-- 后台管理系统登录 -->
    <!-- 头部logo -->
    <div class="top">
      <div class="content1_top">
        <img src="../assets/img/logo2.png" alt="" />
      </div>
    </div>
    <!-- 操作区域 -->
    <div class="content1">
      <div class="content1_bottom">
        <div class="title">管理员登录</div>
        <div class="line-title">账号</div>
        <div class="line">
          <el-input
            v-model="logindata.account"
            placeholder="请输入账号"
            clearable
          ></el-input>
        </div>
        <div class="line-title">密码</div>
        <div class="line">
          <el-input
            placeholder="请输入密码"
            v-model="logindata.password"
            show-password
            clearable
            @keyup.enter.native="Login"
          ></el-input>
        </div>

        <div class="content1_bottom_btn" @click="Login">登录</div>
      </div>
    </div>
    <div class="btm">
      <div class="technicalSupport">{{ this.$technicalSupport }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logindata: {
        account: "",
        password: "",
      },
    };
  },
  methods: {
    // 非空校验
    notnullverification() {
      if (this.logindata.account == "" || this.logindata.password == "") {
        return false;
      }
      return true;
    },
    //错误时清空输入框数据
    cleandata() {
      this.logindata.account = "";
      this.logindata.password = "";
    },
    //登录
    Login() {
      if (this.notnullverification()) {
        let logindata = {
          account: this.logindata.account,
          password: this.logindata.password,
        };
        this.$request("post", "/user/login", logindata, (data) => {
          sessionStorage.setItem("operatorID", data.userId); //审核人id
          sessionStorage.setItem("roleId", data.roleId); // 当前登录用户的角色ID
          sessionStorage.setItem("name", data.name); // 当前登录用户的角色ID
          this.$router.push("/main/realdata");
          this.$message({
            message: "登录成功!",
            type: "success",
            duration: 1000,
          });
        });
      } else {
        this.$message({
          message: "账号或密码不能为空!",
          type: "error",
        });
      }
    },
  },
  mounted() {
    sessionStorage.removeItem("active");
    sessionStorage.removeItem("childActive");
  },
};
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;
  position: relative;
  .top {
    width: 100%;
    height: 26%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 999;
    .content1_top {
      width: 30rem;
      height:6rem;
      box-sizing: border-box;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .content1 {
    width: 100%;
    height: 100%;
    background: url("../assets/img/hfcsxy.jpg") no-repeat;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .content1_bottom {
      width: 30rem;
      height: 380px;
      box-sizing: border-box;
      opacity: 0.96;
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 30px;
      margin-top: 22vh;
      .content1_bottom_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 2.8125rem;
        border-radius: 7px;
        background: rgba(0, 79, 146, 1);
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 5px;
        color: #fff;
        // margin-bottom: 20px;
        &:hover {
          cursor: pointer;
        }
      }
      > .title {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
        font-size: 20px;
      }
      > .line,
      > .line-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      > .line-title {
        margin-bottom: 0;
        height: 40px;
      }
    }
    .fix {
      flex: 1;
    }
  }
  .btm {
    width: 100%;
    height: 5%;
    position: absolute;
    bottom: 0;
    z-index: 999;
    // background: chartreuse;
    .technicalSupport {
      font-size: 14px;
      color: #fff;
    }
  }
}
</style>
